import { Button, Card, Row, SearchInput, Slider } from '@kaleyra/emmy';
import React, { useEffect, useState } from 'react';
import Styles from './index.module.scss';
import templateIcon from '../../../../../../assets/templateIcon.svg';
import cn from "classnames";
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export type OwnProps = {
    data?: any;
    closeOverlaySidebar: () => void;
    showAsOverlaySlider?: boolean;
    _sidebarType: string;
    _getSidebarTyoe: (type: string) => void;
}

export type MapStateType = {
    templatesData: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    updateSelectedTemplateInStore: (templateId: string) => void;
};

const SelectTemplate: React.FC<MapStateType & DispatchPropsType & OwnProps> = ({ onClose, updateSelectedTemplateInStore, templatesData, data, closeOverlaySidebar, showAsOverlaySlider, _sidebarType, _getSidebarTyoe }) => {

    const [selectedTemplate, setSelectedTemplate] = useState<string>("");
    const [templateList, setTemplateList] = useState<any>([]);
    const [searchValue, setSearchValue] = useState("");
    const { t } = useTranslation();

    useEffect(() => {
        if (data) {
            setTemplateList([...data]);
        } else {
            setTemplateList([...templatesData.extraParam.data]);
        }
    }, [data, templatesData]);

    useEffect(() => {
        if (data) {
            if (searchValue !== "") {
                showSearchTemplates(searchValue);
            } else {
                setTemplateList(data || []);
            }
        } else {
            if (searchValue !== "") {
                showSearchTemplates(searchValue);
            } else {
                setTemplateList(templatesData.extraParam.data || []);
            }
        }
    }, [searchValue])

    const showSearchTemplates = (searchValue: string) => {
        if (data) {
            let searchResult = data.filter((value: any) => (value.title.toLowerCase()).includes(searchValue.toLowerCase()))
            setTemplateList(searchResult);
        } else {
            let searchResult = (templatesData.extraParam.data).filter((value: any) => (value.title.toLowerCase()).includes(searchValue.toLowerCase()))
            setTemplateList(searchResult);
        }
    }

    const handleClose = () => {
        if (showAsOverlaySlider) {
            closeOverlaySidebar && closeOverlaySidebar();
        } else {
            onClose();
        }
    }

    const renderSliderFooter = () => {
        return (
            <Row className={cn(Styles.footerRow, showAsOverlaySlider && Styles.footerPosition)}>
                <Button type="tertiary" onClick={() => handleClose()}>{t('mainCancel')}</Button>
                <Button disabled={selectedTemplate === ""} onClick={() => handleSaveTemplate()}>{t('mainSave')}</Button>
            </Row>)
    }

    const handleSaveTemplate = () => {
        updateSelectedTemplateInStore(selectedTemplate);
        if (!showAsOverlaySlider) {
            templatesData.extraParam.getSidebarType(templatesData.extraParam.type);
        } else {
            _getSidebarTyoe(_sidebarType)
        }
        handleClose();
    }

    const handleTemplateSelect = (templateData: any) => {
        setSelectedTemplate(templateData.id);
    }

    const renderTemplateCard = (templateData: any) => {
        return (
            <Card className={cn(Styles.templateBody, selectedTemplate === templateData.id ? Styles.selectedTemplate : "")} showHoverBorder={false}
                key={templateData.id} onClick={() => handleTemplateSelect(templateData)}>
                <Row className={Styles.rowWrapper}>
                    <img src={templateIcon} alt="template-icon" className={Styles.rowIcon} />
                    <div className={Styles.templateInfo}>
                        <span>{templateData.title || "-"}</span>
                        <div className={Styles.dateNameContainer}>
                            <span>{moment(templateData.created_at).format("DD MMM YYYY") || "-"}</span>
                            <span>{templateData.modified_by || "-"}</span>
                        </div>
                    </div>
                </Row>
                <p className={Styles.templateBodyText}>{templateData.content}</p>
            </Card>
        )
    }

    const renderSliderBody = (templateList: any[]) => {
        return (
            <>
                <div className={Styles.modalContainer}>
                    <SearchInput eachChar className={Styles.searchInput} searchStr={searchValue} onChange={(text: any) => setSearchValue(text)} />
                    {
                        templateList.length > 0 ? templateList.map((templateData: any) => renderTemplateCard(templateData)) :
                            <div className={Styles.noData}>
                                <span>{t('mainNoTemplates')}</span>
                            </div>
                    }
                </div>
                {showAsOverlaySlider && renderSliderFooter()}
            </>
        )
    }

    return (
        !showAsOverlaySlider ?
            <Slider
                footer={renderSliderFooter()}
                visibility={true}
                containerId={'root-modal'}
                onClose={() => onClose()}
                title={t('mainSelectTemplate')}>
                {renderSliderBody(templateList)}
            </Slider> :
            <>{renderSliderBody(templateList)}</>
    );
}

export default SelectTemplate;